import { Icon } from "@root/shared/components/Icon";
import { type FC, type ReactNode } from "react";
import * as styles from "./styles.css";

type Props = {
  title: string;
  iconName: string;
  children: ReactNode;
};

export const CassetteTable: FC<Props> = ({ title, iconName, children }) => (
  <div className={styles.outer}>
    <div className={styles.heading}>
      {iconName && (
        <span className={styles.iconOuter}>
          <Icon name={iconName} />
        </span>
      )}
      {title}
    </div>
    <div className={styles.content}>{children}</div>
  </div>
);
